import { render, staticRenderFns } from "./ExtraDetails.vue?vue&type=template&id=320e7990&scoped=true"
import script from "./ExtraDetails.vue?vue&type=script&lang=js"
export * from "./ExtraDetails.vue?vue&type=script&lang=js"
import style0 from "./ExtraDetails.vue?vue&type=style&index=0&id=320e7990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320e7990",
  null
  
)

export default component.exports